import React from 'react'
import { Link } from 'react-scroll'
import get from 'lodash/get'

// import imgHero from '../images/nutid_hero.jpg'
import HeroImg from '../components/images/framtid-hero'
// import VisionImg from '../components/images/vision-image';
import Layout from '../components/layout'

import contentfulClient from '../util/contentful-client'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

import { richTextDocumentToJSX } from '../util/rich-text-to-jsx'
import {
  chunkOnEmptyParagraph,
  customNodeRenderers,
  customMarkRenderers,
} from '../util/rich-text-helpers'

const richTextOptions = {
  renderNode: {
    ...customNodeRenderers,
  },
  renderMark: {
    ...customMarkRenderers,
  },
}

export default class VisionenNewPage extends React.Component {
  state = {
    headline: '',
    preamble: '',
    content: [],
    page_content_middle: [],
    page_content_bottom: [],
    internal_links: [],
    vision_targets: [],
    imageURL: '',
    visionen: [],
  }

  componentDidMount() {
    contentfulClient
      .getEntries({
        content_type: 'visionenNew',
        limit: 1,
      })
      .then((entries) => {
        const entry = entries.items[0]

        if (!entry) return
        // console.log(entry);
        const {
          headline,
          preamble,
          page_content,
          page_content_middle,
          page_content_bottom,
          visionen,
        } = entry.fields

        const vision_targets = entry.fields.vision_targets

        const targets = vision_targets.map((item) => (
          <div key={item.sys.id}>
            <div className="row row-flex row-small">
              <div className="column-half mb text-center">
                {item.fields.item_image && (
                  <img
                    style={{ height: '200px' }}
                    src={item.fields.item_image.fields.file.url}
                  />
                )}
              </div>
            </div>

            <div className="row row-flex row-medium">
              <h3 className="mb">{item.fields.item_headline}</h3>
            </div>

            <div className="row row-columns row-flex row-medium mb">
              <div className="column-half text-left">
                <p>
                  {documentToReactComponents(item.fields.item_content_left)}{' '}
                </p>
              </div>
              <div className="column-half text-left">
                <p>
                  {documentToReactComponents(item.fields.item_content_right)}
                </p>
              </div>
            </div>
          </div>
        ))

        const content = chunkOnEmptyParagraph(page_content).map((chunk, i) => (
          <div
            className="row-darkbg mt-2"
            key={'block-' + i}
            id={'section-' + i}
          >
            <div className="row row-medium">
              {richTextDocumentToJSX(chunk, richTextOptions)}
            </div>
          </div>
        ))

        const content_middle = chunkOnEmptyParagraph(page_content_middle).map(
          (chunk, i) => (
            <div className="mt-2" key={'block-' + i} id={'section-1' + i}>
              <div className="row row-medium">
                {richTextDocumentToJSX(chunk, richTextOptions)}
              </div>
            </div>
          )
        )
        const content_bottom = chunkOnEmptyParagraph(page_content_bottom).map(
          (chunk, i) => (
            <div key={'block-' + i} id={'section-' + i}>
              <div className="row row-medium">
                {richTextDocumentToJSX(chunk, richTextOptions)}
              </div>
            </div>
          )
        )

        const content_visionen = chunkOnEmptyParagraph(visionen).map(
          (chunk, i) => (
            <div key={'block-' + i} id="visionen">
              <div className="row row-medium mt-2">
                {richTextDocumentToJSX(chunk, richTextOptions)}
              </div>
            </div>
          )
        )

        const preamble_content = chunkOnEmptyParagraph(
          preamble
        ).map((chunk, i) => (
          <div>{richTextDocumentToJSX(chunk, richTextOptions)}</div>
        ))

        const imageURL = get(entry, 'fields.image.fields.file.url', '')

        const internal_links = chunkOnEmptyParagraph(page_content).map(
          (chunk, i) => (
            <Link
              key={'link-' + i}
              className="link-internal"
              activeClass="active"
              to={'section-' + i}
              spy={true}
              smooth={true}
              offset={-120}
              duration={500}
            >
              Gemensamma mål
            </Link>
          )
        )

        const internal_links_page_content_middle = chunkOnEmptyParagraph(
          page_content_middle
        ).map((chunk, i) => (
          <Link
            key={'link-' + i}
            className="link-internal"
            activeClass="active"
            to={'section-1' + i}
            spy={true}
            smooth={true}
            offset={-120}
            duration={500}
          >
            Målens innebörd
          </Link>
        ))

        this.setState({
          headline,
          preamble_content,
          content,
          content_middle,
          internal_links,
          internal_links_page_content_middle,

          targets,
          imageURL,
          content_bottom,
          content_visionen,
        })
      })
  }

  render() {
    return (
      <Layout {...this.props}>
        <div className="hero-container ">
          <HeroImg className="w-100" alt="" />
        </div>

        <div className="link-group">
          <div className="row">
            {this.state.internal_links}
            {this.state.internal_links_page_content_middle}
            <Link
              className="link-internal"
              activeClass="active"
              to="visionen"
              spy={true}
              smooth={true}
              offset={-120}
              duration={500}
            >
              Visionen
            </Link>
          </div>
        </div>

        <div className="row row-medium mt-2">
          <h1>{this.state.headline}</h1>
          <h2 className="sub-heading mb">{this.state.sub_headline}</h2>
          <p>{this.state.preamble_content}</p>
        </div>

        {this.state.content}
        {this.state.content_middle}
        {this.state.targets}
        {this.state.content_bottom}
        <div className="row row-medium mb">
          <img src={this.state.imageURL} />
        </div>
        <div id="visionen">{this.state.content_visionen}</div>
      </Layout>
    )
  }
}
